"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTest = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
require("../../../../TdWebtoolkitControls/controls/AddRemoveDialog/AddRemoveDialog");
require("../../../../TdWebtoolkitControls/controls/CategoryChooser/CategoryChooser");
require("./gui_tests.tmpl.less");
const $ = require("jquery");
let markup = require("./gui_tests.tmpl.htm");
let m_$events;
let m_$info;
let m_$controlPane;
let m_$flexer;
let m_$options;
function renderTest() {
    let that = this;
    let contentPane = $("#testContentPane");
    contentPane.html(markup);
    that.m_$events = contentPane.find(".eventTextarea");
    that.m_$info = contentPane.find(".infoTextarea");
    that.m_$controlPane = contentPane.find(".controlsPane");
    that.m_$flexer = contentPane.find(".flexer");
    that.m_$options = contentPane.find(".options");
    let catChooserEvents = [
        "beginInit", "initSuccess", "initFailed", "endInit", "categoriesReceived",
        "dependsChangedManually", "categorySelected", "categorySelectedManually",
        "beforeCategorySelected", "categoriesSelected", "categoriesSelectedManually"
    ];
    let createCatChooser = function ($chooser) {
        let selCookieName = $("#tbSelectionCookieName").val();
        $chooser
            .on("beforeCategorySelected", (evt, obj) => {
            let continueRequested = confirm("Continue with selection?");
            obj.continueCallback(continueRequested);
        })
            .on(catChooserEvents.join(" "), function (ev) {
            appendText(kendo.format("{0:HH:mm:ss.fff} Event \"{1}\"", new Date(), ev.type), that.m_$events);
        })
            .synCategoryChooser({
            useCategoryGroups: $("#cbUseCategoryGroups").prop("checked"),
            showTooltips: $("#cbShowTooltips").prop("checked"),
            showIcons: $("#cbShowIcons").prop("checked"),
            showTreeButton: $("#cbShowTreeButton").prop("checked"),
            showDependsCheckbox: $("#cbShowDependsCheckBox").prop("checked"),
            multiSelect: $("#cbMultiSelect").prop("checked"),
            raiseBeforeSelectionChanged: $("#cbRaiseBeforeSelectionChanged").prop("checked"),
            selectionCookieName: selCookieName ? selCookieName.toString() : undefined
        });
    };
    let $catChooser = $("<div></div>")
        .css("width", "650px")
        .appendTo(that.m_$controlPane);
    createCatChooser($catChooser);
    that.m_$flexer.children("button").on("click", function () {
        let $button = $(this);
        let id = $button.attr("id");
        if (id === "destroy") {
            $catChooser.synCategoryChooser("destroy");
            appendText("...destroyed.", that.m_$info);
        }
        else if (id === "destroyAndRecreate") {
            $("#destroy").trigger("click");
            that.m_$events.text("");
            that.m_$flexer.children("button").attr("disabled", "disabled");
            createCatChooser($catChooser);
            appendText("...created.", that.m_$info);
            that.m_$flexer.children("button").removeAttr("disabled");
        }
        else if (id === "enable") {
            $catChooser.synCategoryChooser("enable", true);
            appendText("...enabled.", that.m_$info);
        }
        else if (id === "disable") {
            $catChooser.synCategoryChooser("enable", false);
            appendText("...disabled.", that.m_$info);
        }
        else if (id === "selectDesktop") {
            $catChooser.synCategoryChooser("setSelectedCategory", 999999999, false, true);
            $("#getSelectedCategory").trigger("click");
            $("#getSelectedCategories").trigger("click");
        }
        else if (id === "selectAcid") {
            $catChooser.synCategoryChooser("setSelectedCategory", 999998115, false, true);
            $("#getSelectedCategory").trigger("click");
            $("#getSelectedCategories").trigger("click");
        }
        else if (id === "selectDesktopAndAcid") {
            $catChooser.synCategoryChooser("setSelectedCategories", [999999999, 999998115]);
            $("#getSelectedCategory").trigger("click");
            $("#getSelectedCategories").trigger("click");
        }
        else if (id === "selectAllCategories") {
            $catChooser.synCategoryChooser("selectAllCategories");
            $("#getSelectedCategory").trigger("click");
            $("#getSelectedCategories").trigger("click");
        }
        else if (id === "areAllSelectd") {
            let allSelected = $catChooser.synCategoryChooser("areAllCategoriesSelected");
            appendText("All categories selected: " + allSelected, that.m_$info);
        }
        else if (id === "areNoSelectd") {
            let allSelected = $catChooser.synCategoryChooser("areNoCategoriesSelected");
            appendText("No categories selected: " + allSelected, that.m_$info);
        }
        else if (id === "hasCat_999999999") {
            appendText("Has category 999999999: " + $catChooser.synCategoryChooser("hasCategory", 999999999), that.m_$info);
        }
        else if (id === "hasCat_1873612") {
            appendText("Has category 1873612: " + $catChooser.synCategoryChooser("hasCategory", 1873612), that.m_$info);
        }
        else if (id === "setDepends") {
            $catChooser.synCategoryChooser("setDepends", true);
        }
        else if (id === "unsetDepends") {
            $catChooser.synCategoryChooser("setDepends", false);
        }
        else if (id === "getSelectedCategory") {
            let cat = $catChooser.synCategoryChooser("getSelectedCategory");
            appendText("Current selection: " + (cat ? cat.id : "(undefined)"), that.m_$info);
        }
        else if (id === "getSelectedCategories") {
            let selectedIds = $catChooser.synCategoryChooser("getSelectedCategories").map(cat => cat.id);
            appendText("Current selection array: " + JSON.stringify(selectedIds), that.m_$info);
        }
        else if (id === "hideTooltip") {
            let $btn = $(this);
            let oldText = $btn.text();
            $btn.attr("disabled", "disabled");
            let timeOut = 3;
            $btn.text("Hiding tooltip in " + timeOut.toString() + " seconds...");
            let intervalId = window.setInterval(() => {
                if (--timeOut <= 0) {
                    $catChooser.find("div.chooserControl").data("kendoTooltip").hide();
                    window.clearInterval(intervalId);
                    $btn.text(oldText).removeAttr("disabled");
                }
                else
                    $btn.text("Hiding tooltip in " + timeOut.toString() + " seconds...");
            }, 1000);
        }
    });
    that.m_$options.find("input:checkbox").change(() => $("#destroyAndRecreate").trigger("click"));
}
exports.renderTest = renderTest;
function appendText(text, $target) {
    if ($target.text())
        $target.append("\r\n");
    $target.append(text);
    $target.scrollTop($target[0].scrollHeight - ($target.height()));
}
